import {
  FETCH_CONFIG_OPTIONS_LOADING,
  FETCH_CONFIG_OPTIONS_SUCCESS,
  FETCH_CONFIG_OPTIONS_ERROR,
  EDIT_CONFIG_OPTION,
  SET_CONFIG_OPTION,
  LOAD_REQUEST,
  LOAD_FAILURE,
  EDIT_CONFIG_OPTIONS_LOADING,
  EDIT_CONFIG_OPTIONS_SUCCESS,
  EDIT_CONFIG_OPTIONS_ERROR,
  COMPLETE_ONBOARDING_LOADING,
  COMPLETE_ONBOARDING_SUCCESS,
  COMPLETE_ONBOARDING_ERROR,
  EDIT_CLIENT_PLUS_LOADING,
  EDIT_CLIENT_PLUS_SUCCESS,
  EDIT_CLIENT_PLUS_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";
import { encodeData } from "~/utils/utils.jsx";

export const getConfigOptions = (...options) => {
  const query = encodeData({ names: options.join(`,`) });

  return {
    types: [FETCH_CONFIG_OPTIONS_LOADING, FETCH_CONFIG_OPTIONS_SUCCESS, FETCH_CONFIG_OPTIONS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/config-options?${query}`,
      }),
  };
};

export const editConfigOption = (name, value) => {
  let body = {};

  body[name] = value;

  return {
    types: [LOAD_REQUEST, EDIT_CONFIG_OPTION, LOAD_FAILURE],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/config-options`,
        method: `put`,
        body,
      }),
    payload: { name, value },
  };
};

export const editClientPlus = (value) => {
  return {
    types: [EDIT_CLIENT_PLUS_LOADING, EDIT_CLIENT_PLUS_SUCCESS, EDIT_CLIENT_PLUS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/client-plus`,
        method: `put`,
        body: { client_plus_enabled: value },
      }),
    payload: { client_plus_enabled: value },
  };
};

export const editConfigOptions = (attributes) => {
  return {
    types: [EDIT_CONFIG_OPTIONS_LOADING, EDIT_CONFIG_OPTIONS_SUCCESS, EDIT_CONFIG_OPTIONS_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/config-options`,
        method: `put`,
        body: attributes,
      }),
    payload: { attributes },
  };
};

export const setConfigOption = (name, value) => ({
  type: SET_CONFIG_OPTION,
  name,
  value,
});

export const completeOnboarding = () => {
  return {
    types: [COMPLETE_ONBOARDING_LOADING, COMPLETE_ONBOARDING_SUCCESS, COMPLETE_ONBOARDING_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/onboarding/complete`,
        method: `put`,
      }),
  };
};
